import CheckoutScreenLoyaltyEnabled from './CheckoutScreenLoyaltyEnabled';

export default CheckoutScreenLoyaltyEnabled;
